import { render, staticRenderFns } from "./DeleteSelected.vue?vue&type=template&id=b3f93f0a&scoped=true"
import script from "./DeleteSelected.vue?vue&type=script&lang=js"
export * from "./DeleteSelected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f93f0a",
  null
  
)

export default component.exports